<div class="overlay" *ngIf="isShow()">
    <p-progressSpinner
        styleClass="w-6rem h-6rem"
        strokeWidth="8"
        animationDuration=".5s"
    ></p-progressSpinner>
    <h3 class="message">{{ getMessage() }}</h3>
</div>
